import { useCallback, useEffect, useMemo } from "react";
import { PageHeader } from "../../../components";
import { Card } from "../../../components/card.component";
import { useAppDispatch, useAppSelector } from "../../../core/redux/ReduxStore";
import { ActionsHHAConfigTable } from "../../../core/redux/slices/sliceHHAConfigTable";
import { AppRouteApi } from "../../../config/appRoute";
import { IPaginationSearchFilter, useTablePaginationSearchFilter } from "../../../hooks";
import { ApiSchemaFilteredDataExchangeSetting } from "../../../models/api/dataExchangeSetting";
import { HHAExchangeConfigList } from "../../../features/hhaConfig/hhaExchangeConfigList.component";

export function PageHHAConfigView() {
  const dispatch = useAppDispatch();
  
  const {
    pageNumber,
    pageSize,
    searchKey,
    nextPageToken,
    shouldRefetch,
  } = useAppSelector((state) => state.hhaConfigTable);

  // Set up API parameters for fetching data
  const apiParams = useMemo<IPaginationSearchFilter["customParams"]>(() => {
    return {
      NextPageToken: nextPageToken,
      PageSize: pageSize,
      PageNumber: pageNumber,
      SearchKey: searchKey,
    };
  }, [nextPageToken, pageSize, pageNumber, searchKey]);

  // Fetch data from the API
  const {
    apiData: hhaConfigData,
    isFetching: isHHAConfigDataFetching,
    refetch: refetchHHAConfig,
  } = useTablePaginationSearchFilter<ApiSchemaFilteredDataExchangeSetting, typeof ActionsHHAConfigTable>(
    ActionsHHAConfigTable,
    {
      customParams: apiParams,
      apiRoute: AppRouteApi.DataExchangeSetting.v1(),
    }
  );

  // Reset data when component unmounts
  const resetData = useCallback(() => {
    dispatch(ActionsHHAConfigTable.resetData());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      resetData();
    };
  }, [resetData]);

  // Refresh data when shouldRefetch is true
  useEffect(() => {
    shouldRefetch && refetchHHAConfig();
  }, [shouldRefetch, refetchHHAConfig]);

  return (
    <Card header={<PageHeader title="HHA Configuration" />}>
      <HHAExchangeConfigList
        totalCount={hhaConfigData?.totalCount || 0}
        data={hhaConfigData?.list}
        isValidating={isHHAConfigDataFetching}
      />
    </Card>
  );
}